import React, { useState } from "react";
import Toasts from "components/Toasts/Toasts";

//Wraps a child component and provide it two methods : showSuccessToast and showErrorToast as props.
function withToasts(WrappedComponent) {
  return function (props) {
    //State management
    const [showToast, setShowToast] = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [toastData, setToastData] = useState({ title: "", message: "" });

    //Controllers.
    const showErrorToast = function (title, message) {
      setErrorToast(true);
      setShowToast(true);
      return setToastData({ title, message });
    };

    const showSuccessToast = function (title, message) {
      setErrorToast(false);
      setShowToast(true);
      return setToastData({ title, message });
    };

    const closeToast = () => setShowToast(false);

    return (
      <React.Fragment>
        <Toasts
          open={showToast}
          closeToast={closeToast}
          title={toastData.title}
          message={toastData.message}
          error={errorToast}
        />
        <WrappedComponent
          showErrorToast={showErrorToast}
          showSuccessToast={showSuccessToast}
          {...props}
        />
      </React.Fragment>
    );
  };
}

export default withToasts;
